import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

import createPersistedState from 'vuex-persistedstate'

import chat from '@/components/chat/chat.js'
import tool from '@/components/tools/tool.js'
import friend from '@/components/friend/friend.js'
import storeManage from '@/components/storeManage/storeManage.js'
import member from '@/components/author/index.js'
import seckill from '@/components/seckill/seckill.js'
import billModel from '@/components/store/billModel.js'
import swipeCode from '@/components/swipeCode/swipeCode.js'
import plaidLotteryPersistentData from '@/components/plaidLottery/plaidLotteryPersistentData.js'
import marketingProgramData from '@/components/chat/marketingProgramData.js'
import birthdayPresent from '@/store/birthdayPresent.js'
import order from '@/pages/order/order.js'
import returnVisit from '@/pages/returnVisit/returnVisit.js'
import userBalance from './userBalance.js'
import checkAgentInfo from './checkAgent.js'
export default new vuex.Store({
    modules: {
        plaidLottery: plaidLotteryPersistentData,
        chat: chat,
        tool: tool,
        friend: friend,
        storeManage: storeManage,
        member: member,
        seckill: seckill,
        swipeCode: swipeCode,
        bill: billModel,
        marketingProgramData: marketingProgramData,
        birthdayPresent: birthdayPresent,
        order,
        returnVisit,
        userBalance,
        checkAgentInfo,
    },
    plugins: [createPersistedState({storage: window.localStorage})] 
})



// WEBPACK FOOTER //
// ./src/store/index.js